import React from 'react'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { Link } from 'react-router-dom'
import { MotionIcon, MotionImage, MotionLink, MotionSection } from '../motion/Motion'

const TIKTOK_URL = 'https://www.tiktok.com/@logobrandeddoormats'
const FACEBOOK_URL = 'https://www.facebook.com/logobrandeddoormatssa'
const INSTAGRAM_URL = 'https://www.instagram.com/logobrandeddoormats/'
const LINKEDIN_URL = 'https://www.linkedin.com/company/logo-branded-door-mats-johannesburg'
const WHATSAPP_URL = 'https://api.whatsapp.com/send/?phone=27810634772&text&type=phone_number&app_absent=0'

export default function Footer() {
  return (
    <MotionSection className="w-full bg-black text-white mt-8">
      <div className="w-[96%] mx-auto py-10 flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
        {/* Left: logo + socials */}
        <div className="flex-1 max-w-sm space-y-5">
          <MotionImage>
            <img
              src="/images/logo/footer logo.png"
              alt="Footer logo"
              className="w-full max-w-sm h-auto object-contain"
            />
          </MotionImage>

          <div className="flex items-center gap-3 text-white">
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <MotionIcon>
                <FacebookIcon className="text-white cursor-pointer hover:text-pink-400 transition-colors" fontSize="small" />
              </MotionIcon>
            </a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <MotionIcon>
                <InstagramIcon className="text-white cursor-pointer hover:text-pink-400 transition-colors" fontSize="small" />
              </MotionIcon>
            </a>
            <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <MotionIcon>
                <LinkedInIcon className="text-white cursor-pointer hover:text-pink-400 transition-colors" fontSize="small" />
              </MotionIcon>
            </a>
            <a href={TIKTOK_URL} target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <MotionIcon>
                <svg viewBox="0 0 24 24" className="w-6 h-6 text-white cursor-pointer hover:text-pink-400 transition-colors fill-current" aria-hidden>
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1.05-.08A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
              </MotionIcon>
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <MotionIcon>
                <WhatsAppIcon className="text-white cursor-pointer hover:text-pink-400 transition-colors" fontSize="small" />
              </MotionIcon>
            </a>
          </div>
        </div>

        {/* Right: columns */}
        <div className="flex-[1.6] grid grid-cols-2 sm:grid-cols-4 gap-8 lg:gap-12 text-sm">
          {/* Contact column */}
          <div>
            <h4 className="font-semibold text-pink-400 mb-3">Contact</h4>
            <ul className="space-y-2 text-gray-200 break-words">
              <li>Call / WhatsApp: +27 (81) 063-4772</li>
              <li>Email: care@logobrandeddoormats.co.za</li>
              <li>Isando, Kempton Park, Gauteng</li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-pink-400 mb-3">Quick Links</h4>
            <ul className="space-y-2 text-gray-200 break-words">
              <li className="hover:text-pink-300">
                <Link to="/">
                  <MotionLink>Home</MotionLink>
                </Link>
              </li>
              <li className="hover:text-pink-300">
                <Link to="/about">
                  <MotionLink>About Us</MotionLink>
                </Link>
              </li>
              <li className="hover:text-pink-300">
                <Link to="/products">
                  <MotionLink>Products</MotionLink>
                </Link>
              </li>
              <li className="hover:text-pink-300">
                <Link to="/gallery">
                  <MotionLink>Gallery</MotionLink>
                </Link>
              </li>
              <li className="hover:text-pink-300">
                <Link to="/contact">
                  <MotionLink>Contact Us</MotionLink>
                </Link>
              </li>
              <li className="hover:text-pink-300">
                <Link to="/terms-and-conditions-of-sale">
                  <MotionLink>Terms and Conditions of Sale</MotionLink>
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-semibold text-pink-400 mb-3">Products</h4>
            <ul className="space-y-2 text-gray-200 break-words">
              <li className="hover:text-pink-300 cursor-pointer">
                <MotionLink>Super Deco Logo Mat</MotionLink>
              </li>
              <li className="hover:text-pink-300 cursor-pointer">
                <MotionLink>Novamat Logo Mat</MotionLink>
              </li>
              <li className="hover:text-pink-300 cursor-pointer">
                <MotionLink>Marshall Scribe Mat</MotionLink>
              </li>
              <li className="hover:text-pink-300 cursor-pointer">
                <MotionLink>Berber Point Logo Mat</MotionLink>
              </li>
              <li className="hover:text-pink-300 cursor-pointer">Coir Custom Logo Mat</li>
              <li className="hover:text-pink-300 cursor-pointer">PVC Coil / Spaghetti Mat</li>
              <li className="hover:text-pink-300 cursor-pointer">Rubber Fingertip Mat</li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-pink-400 mb-3">Company</h4>
            <ul className="space-y-2 text-gray-200 break-words">
              <li className="hover:text-pink-300 cursor-pointer">Why Invest</li>
              <li className="hover:text-pink-300 cursor-pointer">FAQs</li>
              <li className="hover:text-pink-300 cursor-pointer">Contact</li>
              <li className="hover:text-pink-300 cursor-pointer">Gauteng Delivery</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="w-[96%] mx-auto py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-[11px] sm:text-xs text-gray-400">
          <p>© 2025 Logo Branded Door Mats Johannesburg. All rights reserved.</p>
          <p>
            designed by{' '}
            <a
              href="https://www.spemedia.co.zm"
              target="_blank"
              rel="noreferrer"
              className="text-pink-400 hover:text-pink-300 hover:underline"
            >
              speMedia
            </a>
          </p>
        </div>
      </div>
    </MotionSection>
  )
}